import * as React from 'react'
function SvgPhoto(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M32.25 13.25h-4.375L24.9 8.7c-.35-.35-.875-.7-1.4-.7h-7c-.525 0-1.05.35-1.4.7l-2.975 4.55H7.75C6.7 13.25 6 13.95 6 15v15.75c0 1.05.7 1.75 1.75 1.75h24.5c1.05 0 1.75-.7 1.75-1.75V15c0-1.05-.7-1.75-1.75-1.75zM20 27.25c-2.975 0-5.25-2.275-5.25-5.25s2.275-5.25 5.25-5.25 5.25 2.275 5.25 5.25-2.275 5.25-5.25 5.25z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgPhoto
